﻿/* 
Object:         Image
Description:    Logic and events for the module Image
Used in:        Image
*/

window.img = function () {

    return {

        initialize: function() {
            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("Img/Add");
            });
        },

        showItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Set mode 
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // select the item
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Img/Edit?imgId=" + dataItem.ImgID + "&breadcrumbLabel=" + dataItem.Label);

        },

        editItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // Set mode 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // select the item
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("Img/Edit?imgId=" + dataItem.ImgID + "&breadcrumbLabel=" + dataItem.Label);

        },

        deleteItem: function (e) {
            // Prevent default behaviour
            e.preventDefault();

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Post Data
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("Img/Delete?imgId=" + dataItem.ImgID),
                success: function (responseData) {

                    // Refresh datasource grid 
                    $("#imgGrid").data("kendoGrid").dataSource.read();

                }
            });
        }
    }
}();